import { axiosInstance } from './api'

import { Metaverse } from 'types/Metaverse'

export const metaversesApi = {
  getAll() {
    return axiosInstance.get<{ data: Metaverse[] }>('metaverses')
  },
}
